"use client";
import { useEffect, useSyncExternalStore } from "react";
import { useRouter } from "next/navigation";
import { getToken } from "./auth";
import { withNext } from "./authRedirect";
import { subscribeStorage } from "./useClientValue";

// F7: on dört sayfanın kopyaladığı "token yoksa girişe" kapısı, tek hook.
//
// `ready` dönene kadar sayfa veri çekmez (`useEffect(() => { if (!ready) return; ... }, [ready])`).
// Token React'in dışında (localStorage) yaşadığı için `useSyncExternalStore` ile
// okunur: sunucuda ve hydration sırasında "yok" sayılır, hydration biter bitmez
// gerçek değerle yeniden çizilir; başka sekmede çıkış yapılırsa `storage` olayı
// bu sekmeyi de kapıya götürür. Yönlendirme kararı efektte GERÇEK değere bakar,
// hydration anındaki sunucu anlık görüntüsüne değil.
//
// Yönlendirme `replace` ile ve `?next=` taşır (F18): geri tuşu giriş ekranına
// çakılmaz, giriş yapan kişi kaldığı sayfaya döner.
const hasTokenNow = () => Boolean(getToken());
const noTokenOnServer = () => false;

export function useRequireAuth(loginPath: "/login" | "/instructor/login" = "/login"): boolean {
  const router = useRouter();
  const hasToken = useSyncExternalStore(subscribeStorage, hasTokenNow, noTokenOnServer);
  useEffect(() => {
    if (getToken()) return;
    router.replace(withNext(loginPath, window.location.pathname + window.location.search));
  }, [hasToken, loginPath, router]);
  return hasToken;
}
